module.exports = __webpack_public_path__ + "img/5-1.d94446d2.svg";